import {
    AccountSettingWithLangDto,
} from '../../dtos';

import {Action} from '../actions/accountSettingsAndLangActions';
import {ActionType} from '../actionTypes';


export class FlyersStateInitialState implements AccountSettingWithLangDto {
    accountSetting = {};
    languageId = 0;
    loading = false;
    error = null;
    type = null;
}


const initialState = new FlyersStateInitialState();

const reducer = (state: AccountSettingWithLangDto = initialState, action: Action) => {

    switch(action.type)
    {
        //
        case ActionType.SET_ACCOUNT_SETTING_START:
            return { ...state, error: null, loading: true, type: action.type };

        case ActionType.SET_ACCOUNT_SETTING_SUCCESS:
            return {
                ...state,
                accountSetting: action.payload.accountSetting,
                languageId: action.payload.languageId,
                error: null,
                loading: false,
                type: action.type
            };
        case ActionType.SET_ACCOUNT_SETTING_COMPLETE:
            return { ... state, error: null, loading: false, type: action.type};
        case ActionType.SET_ACCOUNT_SETTING_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.SET_ACCOUNT_LANGUAGE_ID:
            return { ...state, error: null, loading: false, type: action.type };

        default:
            return state;
    }
}

export default reducer;